import ProfilePage from './ProfilePage';
export { ProfilePage };



// WEBPACK FOOTER //
// ./src/modules/profile/index.js